<template>
  <el-dialog :title="title" width="70%" :visible.sync="dialogVisible" :before-close="handleClose" :close-on-click-modal="false" top="8vh" append-to-body>
    <eco-table
      @load="loadData"
      :data="tableData"
      :pageResult="pageResult"
      :selectable="selectable"
      :nopagination="nopagination"
      :show-export="false"
      :show-custom-column="false"
      :page-sizes="pageSizes"
      ref="ecoTable"
      v-if="dialogVisible"
    >
      <template v-slot:search v-if="customQuery.conditionfield.length > 0 && isShowSearch">
        <eco-table-search-panel :divide="3">
          <eco-table-search-field
            v-for="(item, $index) in customQuery.conditionfield"
            :type="item.type"
            :key="$index"
            :label="item.comment"
            :prop="item.field"
          />
        </eco-table-search-panel>
      </template>
      <template>
        <eco-table-column type="index" width="50" align="center" label="序号" />
        <eco-table-column
          v-for="(item, $index) in customQuery.resultfield"
          :key="$index"
          :prop="item.field"
          :label="item.comment"
          :sortable="true"
          :show-overflow-tooltip="true"
        ></eco-table-column>
      </template>
    </eco-table>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { Message } from 'element-ui'
import req from '@/request.js'
import utils from '@/eco-ui-util.js'

export default {
  name: 'custom-query-show',
  props: {
    title: {
      type: String,
      required: true,
      default: '关联数据列表预览'
    },
    //关联数据的别名
    alias: {
      type: String,
      required: true
    },
    //关联数据的配置
    customQuery: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      pageSizes: [10], //ht-table组件每页显示的条数
      customQueryPostParam: [], //为REST接口且请求类型是POST，条件字段是固定值的参数
      customQueryGetUrl: '', //为REST接口且请求类型是GET，条件字段是固定值的请求地址
      selectable: false, //表示ht-table列表第一列是否显示复选框
      isShowSearch: false, //是否显示高级搜索
      nopagination: false, //是否隐藏分页组件，false：显示，true：隐藏
      dialogVisible: false, //是否显示关联数据
      tableData: [], //ht-table列表数据
      pageResult: {
        page: 1,
        pageSize: 20,
        total: 0
      }
    }
  },
  methods: {
    //显示关联数据
    showDialog() {
      this.customQueryPostParam = [] //清空为REST接口且请求类型是POST，条件字段是固定值的参数
      this.customQueryGetUrl = '' //清空为REST接口且请求类型是GET，条件字段是固定值的请求地址
      this.isShowSearch = false //不显示高级搜索
      this.dialogVisible = true
      this.pageSizes = [this.customQuery.pageSize] //把关联数据配置的分页大小赋值给ht-table组件每页显示的条数
      //是否显示分页组件，1：显示，0：隐藏
      if (this.customQuery.needPage == 1) {
        this.nopagination = false
      } else {
        this.nopagination = true
      }
      //判断是否有条件查询,且数据来源是数据源或者数据来源是REST接口且请求类型是POST
      if (
        this.customQuery.conditionfield.length > 0 &&
        (this.customQuery.dsType == 'dataSource' || (this.customQuery.dsType != 'dataSource' && this.customQuery.requestType == 'POST'))
      ) {
        for (let i = this.customQuery.conditionfield.length - 1; i >= 0; i--) {
          //判断条件字段是否是参数传入并控制器的类型为单行文本框  （controllerType有值就代表控制器的类型为单行文本框，defaultType：1：参数传入，2：固定值 ）
          if (this.customQuery.conditionfield[i].controllerType && this.customQuery.conditionfield[i].defaultType == '1') {
            this.isShowSearch = true //显示高级搜索
            //如果条件字段为data类型，则控制器的类型为日期类型
            if (this.customQuery.conditionfield[i].dbType == 'date') {
              this.customQuery.conditionfield[i].type = 'date'
            } else {
              this.customQuery.conditionfield[i].type = 'text'
            }
          } else {
            if (this.customQuery.dsType != 'dataSource' && this.customQuery.requestType == 'POST') {
              this.customQueryPostParam.push(this.customQuery.conditionfield[i]) //为REST接口且请求类型是POST，条件字段是固定值的参数
            }
            //如果是条件字段固定值就清除
            this.customQuery.conditionfield.splice(i, 1)
          }
        }
      }
      //判断是否有条件查询,且数据来源是REST接口且请求类型是GET
      if (this.customQuery.conditionfield.length > 0 && this.customQuery.dsType != 'dataSource' && this.customQuery.requestType == 'GET') {
        for (let i = this.customQuery.conditionfield.length - 1; i >= 0; i--) {
          //判断条件字段是否是固定值（defaultType：1：参数传入，2：固定值 ）
          if (this.customQuery.conditionfield[i].defaultType == '2') {
            //判断请求地址是否带有 ？
            if (this.customQuery.url.indexOf('?') == -1) {
              //无
              this.customQuery.url =
                this.customQuery.url + '?' + this.customQuery.conditionfield[i].field + '=' + this.customQuery.conditionfield[i].defaultValue
            } else {
              //有
              this.customQuery.url =
                this.customQuery.url + '&' + this.customQuery.conditionfield[i].field + '=' + this.customQuery.conditionfield[i].defaultValue
            }
            //如果是条件字段固定值就清除
            this.customQuery.conditionfield.splice(i, 1)
            this.customQueryGetUrl = this.customQuery.url
            //判断条件字段是否是参数传入并控制器的类型为单行文本框（controllerType有值就代表控制器的类型为单行文本框，defaultType：1：参数传入，2：固定值 ）
          } else if (this.customQuery.conditionfield[i].controllerType && this.customQuery.conditionfield[i].defaultType == '1') {
            this.isShowSearch = true //显示高级搜索
          }
        }
      }
    },
    // 处理POST请求时的参数
    handleDataParam(param) {
      if (!this.customQuery.dataParam || this.customQuery.dataParam.constructor != String) {
        return param
      }
      // 构建上下文数据对象
      let ctx = {}
      param.querys &&
        param.querys.forEach((element) => {
          ctx[element.property] = element.value
        })
      const exp = utils.parseExp(this.customQuery.dataParam, ctx)
      try {
        const paramLoadData = JSON.parse(exp)
        return paramLoadData
      } catch (e) {
        Message.error(`POST参数不是有效的JSON格式${this.customQuery.dataParam}`)
      }
    },
    // 对Restful请求的返回数据进行统一的处理
    handleResponseData(data, rowsKey) {
      if (!data) {
        Message.error('返回的数据为空')
      }
      if (data.constructor == String) {
        try {
          data = JSON.parse(data)
        } catch (e) {
          Message.error(`将返回值解析为JSON对象时出错了：${e}`)
          throw e
        }
      }

      if (data.constructor == Object) {
        // 如果没有指定提取key，则将返回值包装为列表
        if (!rowsKey) {
          return [data]
        }
        try {
          return utils.getValueByPath(data, rowsKey)
        } catch (e) {
          Message.error(`从返回的数据中提取数组时出错了：${e}`)
          throw e
        }
      } else if (data.constructor == Array) {
        // 已经是数组类型时，不再通过rowsKey提取
        return data
      } else {
        const msg = `返回的数据无法解析:${data}`
        Message.error(msg)
        throw msg
      }
    },
    //加载数据
    async loadData(param, cb) {
      let paramLoadData = [] //关联数据查询参数（传入后台的）
      let page = 1 //ht-table的数据默认显示第一页的（数据来源是数据源的情况）
      //数据来源是数据源
      if (this.customQuery.dsType == 'dataSource') {
        //判断ht-table组件的分页查询参数是否为空
        if (JSON.stringify(param.pageBean) != '{}') {
          page = param.pageBean.page //根据ht-table组件的分页查询参数显示第几页数据就查询第几页的
        }
        //判断ht-table组件的条件查询参数是否为空
        if (param.querys && param.querys.length > 0) {
          for (let i = 0; i < param.querys.length; i++) {
            let obj = {
              key: param.querys[i].property,
              value: param.querys[i].value
            }
            paramLoadData.push(obj)
          }
        }
      }
      //数据来源是REST接口且请求类型是POST
      if (this.customQuery.dsType != 'dataSource' && this.customQuery.requestType == 'POST') {
        //判断条件字段是否有固定值的参数
        if (this.customQueryPostParam.length > 0) {
          for (let i = 0; i < this.customQueryPostParam.length; i++) {
            //构建查询条件
            let obj = {
              group: 'main',
              operation: 'LIKE',
              property: this.customQueryPostParam[i].field,
              relation: 'AND',
              value: this.customQueryPostParam[i].defaultValue
            }
            if (param.querys && param.querys.length > 0) {
              param.querys.push(obj)
            } else {
              param.querys = []
              param.querys.push(obj)
            }
          }
        }
        paramLoadData = this.handleDataParam(param)
      }
      //判断是否有条件查询,且数据来源是REST接口且请求类型是GET，并且判断参数传入是否填写了查询条件
      if (
        this.customQuery.conditionfield.length > 0 &&
        this.customQuery.dsType != 'dataSource' &&
        this.customQuery.requestType == 'GET' &&
        param.querys &&
        param.querys.length > 0
      ) {
        for (let i = this.customQuery.conditionfield.length - 1; i >= 0; i--) {
          //判断条件字段是否是参数传入并控制器的类型为单行文本框（controllerType有值就代表控制器的类型为单行文本框，defaultType：1：参数传入，2：固定值 ）
          if (this.customQuery.conditionfield[i].controllerType && this.customQuery.conditionfield[i].defaultType == '1') {
            //参数传入填写了查询条件
            for (let j = 0; j < param.querys.length; j++) {
              //判断为REST接口且请求类型是GET，条件字段是固定值的请求地址是否为空
              if (this.customQueryGetUrl != '') {
                this.customQuery.url = this.customQueryGetUrl //赋值为REST接口且请求类型是GET，条件字段是固定值的请求地址
              } else {
                this.customQueryGetUrl = this.customQuery.url
              }
              //判断请求地址是否带有?
              const linkWord = this.customQuery.url.indexOf('?') == -1 ? '?' : '&'
              this.customQuery.url = `${this.customQuery.url}${linkWord}${param.querys[j].property}=${param.querys[j].value}`
            }
          }
        }
      } else {
        //判断为REST接口且请求类型是GET，条件字段是固定值的请求地址是否为空
        if (this.customQueryGetUrl != '') {
          this.customQuery.url = this.customQueryGetUrl //赋值为REST接口且请求类型是GET，条件字段是固定值的请求地址
        }
      }
      let queryUrl =
        this.customQuery.dsType == 'dataSource' ? '${form}/form/customQuery/v1/doQuery?alias=' + this.alias + '&page=' + page : this.customQuery.url

      // 处理url地址中的${服务名}
      queryUrl = utils.parseUrl(queryUrl)
      let requestMethod = 'POST'
      //如果关联数据列表查询数据不是数据源则请求方法为restful配置的请求方式
      if (this.customQuery.dsType != 'dataSource') {
        requestMethod = this.customQuery.requestType
      }
      //查询数据
      let response = await req
        .request({
          url: queryUrl,
          method: requestMethod,
          data: paramLoadData,
          headers: this.customQuery.header
        })
        .finally(() => cb())

      //如果数据来源是数据源
      if (this.customQuery.dsType == 'dataSource') {
        this.tableData = response.data.rows
        //如果有分页
        if (response.data.page) {
          this.pageResult = {
            page: response.data.page,
            pageSize: response.data.pageSize,
            total: response.data.total
          }
          this.nopagination = false //显示分页组件
        } else {
          this.nopagination = true //隐藏分页组件
        }
      } else {
        // 如果数据来源是REST接口
        this.tableData = this.handleResponseData(response.data, this.customQuery.listKey)
        // restful接口类型不处理分页（在构建请求的数据时可以构建分页请求参数）
        this.nopagination = true //隐藏分页组件
      }
    },
    //关闭关联数据
    handleClose() {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.el-main {
  padding-top: 0px;
}
</style>
